import { render } from "./ExamenVIew.vue?vue&type=template&id=8d1fa3fc&ts=true"
import script from "./ExamenVIew.vue?vue&type=script&lang=ts"
export * from "./ExamenVIew.vue?vue&type=script&lang=ts"

import "./ExamenVIew.vue?vue&type=style&index=0&id=8d1fa3fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__